import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import { DataGrid, getGridStringOperators, GridToolbar } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useEffect, useState, useContext, useCallback } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { useNavigate } from "react-router-dom";
import DeleteShortVideos from "./DeleteShortVideos";
import { shortVideoApi } from "../../store/shortVideo/shortVideoList";
import { resetShortVideo } from "../../store/shortVideo/shortVideoDetail";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import BulkShortVideo from "./BulkShortVideo";
import { ThemeContext } from '../../context/ThemeContext';
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import BackdropUI from "../../ui/Backdrop";
import PublishUnpublishModule from "../../components/PublishUnpublishModule";
import DataGridComponent from "../../components/DataGridComponent";
import PermissionGate from "../../components/PermissionGate";

export default function ManageShortVideo() {
  const shortVideo = useSelector((state) => state?.shortVideo);
  const { result, loading, total } = shortVideo;
  const [deleteId, setDeleteId] = useState(null);
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDownload, setIsDownload] = useState(false)
  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const [openPublish, setOpenPublish] = useState(false);
  const [bulkShortVideo, setBulkShortVideo] = useState(false);
  const [queryOptions, setQueryOptions] = useState({});

  const columns = [
    {
      field: "id",
      headerName: "Short Videos Id",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "title",
      headerName: "Title",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },

    {
      field: "points",
      headerName: "Stars",
      filterable: false,
      sortable: false,
      width: 100,
    },
    {
      field: "video_url",
      headerName: "Video Url",
      filterable: false,
      sortable: false,
      width: 400,
    },
    {
      field: "image",
      headerName: "Thumbnail Image",
      filterable: false,
      sortable: false,
      width: 250,
      renderCell: (params) => (
        <Box sx={{ py: 1 }}><img width={200} height={100} src={params.row.banner} alt='banner image' /></Box>)
    },
    {
      field: "category",
      headerName: "Category",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 150,
    },
    {
      field: "publish",
      headerName: "Publish Short Video",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="short_videos" action={row.row.published ? "unpublish" : "publish"}>
            <Button
              color="info"
              onClick={() => {
                setOpenPublish(true)
                setDeleteId(row.id)
                setSelectedRow(row.row)
              }}
              endIcon={<ArrowRightAltIcon />}>
              {row.row.published ? "Unpublish" : "Publish"}
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "update_shortvideo",
      headerName: "Update ShortVideo",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="short_videos" action="update">
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available" variant="outlined"
              onClick={() => navigate(`/edit-short-video/${row.id}`)}
            >
              Edit
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "delete_shortvideo",
      headerName: "Delete ShortVideo",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="short_videos" action="delete">
            <Button
              endIcon={<DeleteOutlineIcon />}
              color="error"
              variant="outlined"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                setNotSelectedProductModel(true);
                setDeleteId(row.id);
              }}
            >
              Delete
            </Button>
          </PermissionGate>
        </>
      ),
    },
  ];

  const addToCartHandler = async () => {
    navigate("/add-short-video");
  };

  const getShortVideoList = useCallback((queryOptions, paginationModel) => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(shortVideoApi(query));
  }, [dispatch])

  useEffect(() => {
    getShortVideoList(queryOptions, paginationModel)
    dispatch(resetShortVideo());
  }, [dispatch, paginationModel, queryOptions, getShortVideoList]);

  const onFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);


  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Short Videos List</Typography>
        </Stack>

        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>
            <PermissionGate module="short_videos" action="create">
              <Button
                onClick={addToCartHandler}
                variant="contained"
              >
                Add New Short Video
              </Button>
            </PermissionGate>
            <PermissionGate module="short_videos" action="upload">
              <Button
                onClick={() => setBulkShortVideo(true)}
                variant="contained"
              >
                Add Bulk Short Videos
              </Button>
            </PermissionGate>
          </Stack>
        </Stack>

        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
              height: 500
            }}
            getRowId={(row) => row.id}
            rows={result}
            columns={columns}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "shortVideosManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, permissionModule: "short_videos", apiUrl: apiRoutes.shortVideosList })),
            }}
            slotProps={{
              loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'linear-progress',
              },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>

      </Body>

      <DeleteShortVideos
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        setSelectedRow={setSelectedRow}
        id={deleteId}
      />
      <BulkShortVideo
        open={bulkShortVideo}
        setOpen={setBulkShortVideo}
      />
      <PublishUnpublishModule
        open={openPublish}
        setOpen={setOpenPublish}
        selectedRow={selectedRow}
        queryOptions={queryOptions}
        paginationModel={paginationModel}
        moduleType={"short_videos"}
        moduleList={getShortVideoList}
      />
      <BackdropUI open={isDownload} />
    </>
  );
}
